module.exports = __webpack_public_path__ + "images/emoji/wine_glass.42cfd0e11501e91b02e4.png";